export class PromiseTimeoutError extends Error {
  constructor(label: string) {
    super(`timeout:${label}`);
    this.name = 'PromiseTimeoutError';
  }
}

/**
 * Race an async task against a deadline.
 *
 * Pass a function that uses `await` on Zoom SDK calls — never pass the SDK
 * return value directly. The SDK proxy treats `.then` as an API name.
 */
export function withTimeout<T>(fn: () => Promise<T>, ms: number, label: string): Promise<T> {
  let timer: ReturnType<typeof setTimeout>;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => reject(new PromiseTimeoutError(label)), ms);
  });
  return Promise.race([fn(), timeout]).finally(() => clearTimeout(timer!));
}
